import moment from 'moment'

export const config = {
  rowSelection: false,
  columns: [
    {
      title: '序号',
      dataIndex: 'id',
      width: 150,
      name: 'id',
    },
    {
      title: '销售业务名称',
      dataIndex: 'companyName',
      width: 200,
      name: 'companyName',
      ellipsis: {
        showTitle: false,
      }
    },
    {
      title: '适用组织范围',
      dataIndex: 'regionName',
      width: 200,
      name: 'regionName',
      ellipsis: {
        showTitle: false,
      }
    },
    {
      title: '创建时间',
      dataIndex: 'lastUpdatedTime',
      name: 'lastUpdatedTime',
      width: 180,
      render: v => {
        return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '名称',
      name: 'cityCode',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
